import React from 'react';
import { Navigation, RadioOption } from '../components/FormControls';
import { PhotoField } from '../components/PhotoField';
import { StepProps, PhotoHandler } from './sectionTypes';

export const DadosCriancaStep = ({
  form,
  etapaCompleta,
  updateForm,
  input,
  onNext,
  handlePhoto,
  handleDataNascimento,
  handleCotaChange,
  handleNomeChange
}: StepProps & {
  handlePhoto: PhotoHandler;
  handleDataNascimento: (value: string) => void;
  handleCotaChange: (value: string) => void;
  handleNomeChange: (value: string) => void;
}) => (
  <section className="form-section">
    <h2><span className="section-icon">👤</span>Dados da Criança</h2>
    <PhotoField
      id="foto"
      label="Foto do Participante *"
      image={form.fotoUrl}
      centered
      onSelect={(event) => handlePhoto(event, (url) => updateForm('fotoUrl', url))}
      onRemove={() => updateForm('fotoUrl', '')}
    />

    <div className="form-group association-group">
      <label className="association-label">É associado do UBA CLUBE?</label>
      <div className="radio-group">
        <RadioOption label="✅ SIM, ASSOCIADO – R$ 220,00" checked={form.associadoUba} onChange={() => updateForm('associadoUba', true)} />
        <RadioOption
          label="❌ NÃO, NÃO ASSOCIADO – R$ 300,00"
          checked={!form.associadoUba}
          onChange={() => {
            updateForm('associadoUba', false);
            updateForm('codigoAssociado', '');
            updateForm('gratuito', false);
          }}
        />
      </div>
    </div>

    {form.associadoUba && (
      <div className="form-group">
        <label htmlFor="codigoAssociado">Número de Cota UBA *</label>
        <input id="codigoAssociado" className="form-input" placeholder="Digite seu número de cota" value={form.codigoAssociado} onChange={(event) => handleCotaChange(event.target.value)} required />
        <small className="form-help">Digite o número de cota fornecido pelo UBA CLUBE</small>
      </div>
    )}

    <div className="form-group">
      <label htmlFor="nomeCompleto">Nome Completo do Participante *</label>
      <input id="nomeCompleto" type="text" required value={form.nomeCompleto} onChange={(event) => handleNomeChange(event.target.value)} />
    </div>

    <div className="form-group">
      <label htmlFor="dataNascimento">Data de Nascimento do Participante *</label>
      <input id="dataNascimento" type="text" placeholder="DD/MM/AAAA" maxLength={10} inputMode="numeric" required value={form.dataNascimento} onChange={(event) => handleDataNascimento(event.target.value)} />
    </div>

    {form.turma && (
      <div className="form-group">
        <label>Turma do Participante</label>
        <div className="turma-info"><span className="turma-nome">{form.turma}</span></div>
      </div>
    )}

    <Navigation disabled={!etapaCompleta[1]} onNext={onNext} />
  </section>
);
